function toggleTooltip(this: HTMLElement) {
  document
    .querySelectorAll('.tooltip-modified__item')
    .forEach((tooltipItem) => tooltipItem.classList.remove('visible'))
  document
    .querySelectorAll('.tooltip-mobile')
    .forEach((tooltipMobile) => tooltipMobile.classList.remove('visible'))

  this.nextElementSibling?.children[0].classList.toggle('visible')
  if (this.nextElementSibling?.children[0].classList.contains('visible')) {
    this.classList.add('active')
  }
}

document.querySelectorAll('.tooltip-modified__initiator').forEach((tooltip) => {
  tooltip.addEventListener('click', () => {
    document
      .querySelectorAll('.tooltip-modified__initiator')
      .forEach((tooltip) => tooltip.classList.remove('active'))
  })
  tooltip.addEventListener('click', toggleTooltip, false)
})

// save content of tooltip to clipboard

window.addEventListener('DOMContentLoaded', () => {
  const tooltipEls = document.querySelectorAll('.tooltiptext')

  tooltipEls.forEach(function (tooltipEl) {
    tooltipEl.addEventListener('click', function (event) {
      event.stopPropagation()
      event.preventDefault()

      const tooltipText = tooltipEl.innerText

      navigator.clipboard.writeText(tooltipText).then(
        function () {
          tooltipEl.innerText = 'Text kopiert'
        },
        function (error) {
          tooltipEl.innerText = 'Fehler beim kopieren'
        }
      )
    })
  })

  const anchorEls = document.querySelectorAll('a')

  anchorEls.forEach(function (anchorEl) {
    anchorEl.addEventListener('click', function (event) {
      const tooltipEl = anchorEl.querySelector('.tooltiptext')

      if (tooltipEl && tooltipEl.contains(event.target)) {
        event.preventDefault()
      }
    })
  })
})
